import { reduceStrArrToMap } from '../../../utils';

/**
 * 作用是第一次提交触发校验后弹框确认，再次提交时候需要传这个参数后端就会跳过校验
 * 优惠剥夺 1 准时保 2 一口价 3
 *
 * */
const SKIP_VERIFY_CODE = {
  BAN_PROMOTION: 1,
  PUNCTUAL: 2,
  FIXEDPRICE: 3,
};

const LX_CODES = {
  SHOP_OFFLINE: 201003201, // 店铺下架
  SHOP_CLOSE: 201003401, // 店铺休息
  REQUIRED: 2000012, // 必选品拦截
  BAN: 2000002, // 风控禁止下单
  COUPON_DISABLE: 2000008, // 优惠券无法使用
  OUTOF_SERVICE: 2000001, // 超出服务范围
};
const SAFE_AREA = Mach.env.safeAreaInsets;
const SAFE_AREA_BOTTOM = Mach.env?.safeAreaInsets?.bottom || 16;

enum ADDRESS_TYPE {
  add = 1, // 新增地址
  select = 2, // 选择地址
  recommend = 3, // 推荐地址（说明可以选择）
}

// 地址选择状态
const ADDRESS_STATUS = {
  unSelect: 0, // 未选择地址
  noAddress: 1, // 无地址
  selected: 2, // 已选地址
  invalid: 3, // 地址无效
};

const HINT_EXPERIMENT = '1';

// 什么情况触发的order/update接口
const UPDATE_TYPE = {
  charge: 1, // 小费
  remark: 2, // 备注
  payFail: 3, // 支付失败
  address: 4, // 修改地址
};

// 支付一体化 支付失败 跳回提单页
const CANCEL_ORDER_SCENE = 1;

const CANCEL_SCENE = {
  passiveCancel: 1, // 支付明确失败
  activeCancel: 2 // 主动退出支付
};
// 订单token过期
const ORDER_TOKEN_INVALID = 2000013;
// 备注风控
const REMARK_BAN = 201003405;
/**
 * update 需要独立处理的code
 */
const UPDATE_ERROR_CODE = {
  ORDER_TOKEN_INVALID, // 订单token失效
};
/**
 * submit异常码类型
 */
const ERROR_CODE = {
  DUE_RAMADAN: 2000041, // 临界封斋
  LATE_RAMADAN: 2000042, // 超过封斋
  BAN_PROMOTION: 2000003, // 提单接口： 风控 优惠剥夺 异常code
  PUNCTUAL_BAN: 2000004, // 提单接口：准时保风控触发
  PUNCTUAL_COUNT_LIMIT: 2000005, // 提单接口：准时保频次限制
  PUNCTUAL_OFF: 2000007, // 提单接口：准时保开关已关
  OUT_OF_STOCK: 2000006, // 提单接口/update 接口 库存为0
  NOT_BIND_PHONE: 201003403, // 提单未绑定手机号
  ORDER_TOKEN_INVALID, // 订单token失效
  DISCOUNT_ACTIVITY_INVALID: 2000009, // 折扣菜活动失效
  PRODUCT_OFF: 2000011, // 商品下架、删除
  PAY_METHOD_NOT_MATCH: 2000017, // 支付方式不匹配
  CANCEL_REPEAT_ORDER_FAIL: 201003406, // 取消已经重复的订单
  NEW_USER_INVALID: 2000015, // 门店新客失效
  NEW_USER_VALID: 2000016, // 门店新客生效
  Events919_USER_NOT_HAVE_ACCESS: 2000018, // 用户不再享受919活动
  Events919_SKU_NOT_HAVE_ACCESS: 2000019, // 919活动商品库存不足
  Events919_OFFLINE: 2000020, // 919活动下线
  NOT_SUPPORT_PICKUP: 201003410, // 门店支持的取货模式不匹配
  SKU_LIST_EMPTY: 2000025, // 商品列表为空
  FAR_AWAY_SHOP: 2000022, // 下单时，用户距离商家太远提示
  PAY_SUCCESS: 201003408, // 调用取消接口的时候，查询订单已经支付成功了，跳转到订单详情页
  NO_SELECT_PRODUCE: 2000027, // 自提场景，未选择必选商品
  MULTI_STEP_ACTIVITY: 2000028, // 多阶梯活动拦截
  ORDER_REPEAT_PAY: 2000014, // 订单已支付
  NEWCOMER_ALL_DISCOUNT_FOOD_INVALID: 2000029, // 门店新客全部折扣菜不可用
  NEWCOMER_PARTIAL_DISCOUNT_FOOD_INVALID: 2000030, // 门店新客部分折扣菜不可用
  RISK_BAN_KOUPON: 2000040, // 券包风控拦截
  DELIVERY_SERVICE_CHANGE: 2000043, // 配送服务不一致
  ORDER_PRICE_HIGHER: 2000039, // 订单价格变高
  ORDER_CANCELED: 2000050, // 订单已取消
  SAFETY_INFO_CHECK: 3000001, // 安全检查
  SAFETY_INFO_PARAMS_OVERTIME: 3000002, // 安全检查参数有误（过期，需清空）
  PREPARE_CASH_CHECK: 3000003, // 现金准备检查
  PT_LARGE_ORDER_BAN_SUBMIT: 2000046, // PT大订单拦截下单
  PT_NOT_MEET_DELIVERY_MIN_FEE_LIMIT: 2000047, // PT订单不满足起送价
  NOT_MEET_MIN_FEE_LIMIT: 2000048, // 订单不满足起送价
  SECONDARY_CONFIRM: 4000001, // 提单页二次确认
  CASH_PAY_INTERCEPT: 2000049, // 现金支付拦截
  ADDRESS_INVALID: 101003408, // 无效地址
  BLACK_REGION: 2000051, // 黑区，禁止下单
  AGE_CHECK_NO_PASSED: 2000052, // 年龄检查未通过(酒类订单未成年检查)
  AGE_CHECK_NO_RESULT: 2000053, // 年龄检查无结果(酒类订单未成年检查)
};

// 101: 出餐慢
// 102: 恶劣天气保单
const TIP_CODE = {
  APPROACHING_FASTING: 201, //接近封斋提醒
  DUE_TO_FASTING: 202, //临近封斋提醒
  LATE_FASTING: 203, //晚于封斋提醒
  SELF_DELIVERY: 204, // 商家自配
};

const SAFETY_CHECK_CODE = {
  CPF_CHECK: 1, // 安全检查-CPF
  FACE_YODA_CHECK: 2, // 安全检查-人脸
};

// CPF检查场景
enum CPF_CHECK_SCENE {
  RISK_CHECK = 1, // 风控
  SAFETY_CHECK = 2, // 安全
}

/**
 * 库存不足时刷新折扣菜为普通菜入参
 */
enum REFRESH_TOKEN_TYPE {
  NORMAL = 0, // 正常状态
  REFRESH = 1, // 刷新
}

const VOUCHER_MODULE_ADD_OFFSET = 20;
const SCROLL_OFFSET = 10;

/**
 * 业务接口返回的收银台类型（对应preview、update接口返回的tradeVersion字段值）
 */
enum CASHIER_DESK_TYPE {
  NORMAL = '0', // 标准收银台
  FRONT = '1', // 前置收银台
}

/**
 * 支付侧降级时，支付组件回调返回的收银台类型
 */
enum PAY_RESPONSE_CASHIER_TYPE {
  STANDARD = 'sailor_standard_cashier', // 标准收银台
  PRE = 'sailor_pre_cashier', // 前置收银台
}

/**
 * 前置收银台支付场景类型
 */
enum FRONT_PAYMENT_ACTION_TYPE {
  INIT_PAYMENT = 'pay_component_finished', // 支付组件初始化
  SHOW_PAYMETHOD = 'guide_user_select_pay_method', // 展示支付方式
  UPDATE_PAYMETHOD = 'update_pay_method', // 选择限制类优惠券通知支付组件更改支付方式
  CHANGE_PAYMETHOD = 'pay_method_changed', // 组件渲染成功和用户主动更换支付方式
  START_CASHIER = 'start_cashier', // 调用前置收银台
  REPORT_INFO = 'report_info', //
  UPDATE_TRADE_AMOUNT = 'update_trade_amount', // 支付组件更新总金额
  UPDATE_PRE_DECISION = 'update_pre_decision', // 传递支付侧决策数据
  SEND_PAY_METHODS = 'send_user_select_pay_methods', // 传递支付方式列表
  SCROLL_TO_PAY_COMPONENT = 'scroll_to_pay_component', // 滚动到支付组件
}

/**
 * preDecisionSceneCode 优惠变更标识
 */
enum PRE_DECISION_SCENE_CODE {
  NONE = 200001, // 无优惠变更场景
  APPLIED = 200002, // 优惠变更场景
  BIND_CARD = 200003, // 绑卡签约场景
}

const couponListSchemeCommonParams = {
  features: {
    voucherPackage: {
      supported: true
    },
    bundleName: Mach.env?.bundleName ?? '',
    bundleVersion: Mach.env?.bundleVersion ?? ''
  }
};

/**
 * 支付组件相关Code
 */
enum FRONT_PAYMENT_CODE {
  RENDER_SUCCESS = 10000200, // 渲染成功
  RENDER_FAILED = 10000502, // 渲染失败
  PAY_SUCCESS = 10001200, // 支付成功
  PAY_ERROR = 10001401, // 1.用户网络不好导致接口失败/超时  2.下游抖动导致的接口错误/超时
  PAY_BACKEND_ERROR = 10001402, // 支付轮询了支付结果5s后，状态依旧在处理中
  PAY_BEHAVIOR_ERROR = 10001403, // 用户行为导致支付失败（关闭支付浮层等等）
  PAY_FRONT_ERROR = 10001404, // 明确支付失败
  PAY_UNKNOW_ERROR = 10001405, // 支付前端未知错误
  UPDATE_PAYMETHOD_SUCCESS = 30301200, // 更换支付方式成功(默推和手动切换场景)
  UPDATE_PAYMETHOD_UNSELECTED = 30301401, // 用户未选择任何支付方式(默推场景)
  UPDATE_PAYMETHOD_UNAUTHORIZED = 30301402, // 用户授权未完成【支付宝未签约】
  UPDATE_PAYMETHOD_UNINSTALL_APP = 30301403, // 用户未安装APP【未安装微信App】
  UPDATE_PAYMETHOD_INTERNAL_ERROR = 30301404, // 支付内部错误【接口错误、通道错误】
  UPDATE_PAYMETHOD_FAILED = 30301405, // 用户切换支付方式失败
}

/**
 * 支付方式标识
 */
enum FRONT_PAYMENT_METHOD {
  NONE = '', // 无支付方式
  BIND_CARD = 'bindcard', // 银行卡支付
  APPLE = 'applepay', // Apple支付
  ALIPAY = 'alipay', // 支付宝
  ALIPAY_HK = 'alipay_hk', // 支付宝HK
  WECHAT = 'wechatpay', // 微信支付
  PAYME = 'paymepay', // Payme
  OCTOPUS = 'octopuspay', // 八达通
  GOOGLEPAY = 'googlepay',
  CASH = 'cash', // 现金
}

/**
 * 支付组件默认初始化时间
 */
const INIT_PAYMENT_TIMEOUT_DURATION = {
  IOS: 800,
  ANDROID: 1000,
};

// 取消接口失败尝试次数
const DEFAULT_CANCEL_COUNT = 3;

/**
 * 当前选择的优惠券类型
 */
enum SELECT_COUPON_TYPE {
  UNLIMIT = 0, // 非限制类优惠券或没有使用优惠券
  LIMIT = 1, // 限制类优惠券
}

const PREVIEW_PROMAOTE_TEST_MARK_AB_SWITCH = 'previewPromoteTestMark';

/**
 * 切换支付方式来源
 */
enum CHANGE_PAYMETHOD_REFERER_TYPE {
  RECOMMEND = 0, // 默推支付方式
  MANUAL = 1, // 手动切换
}

/**
 * 修改备注错误code
 */
const SAVE_ADDRESS_ERROR_CODE = {
  ban: 201002205, // 风控
};

const UPDATE_ADDRESS_STATUS = {
  init: 0,
  fail: 1,
};
// 大订单表示
const LARGE_ORDER_CODE = 4;

enum UserGetMode {
  delivery = 'delivery',
  pickup = 'pickup',
}

const UPDATE_STATUS = {
  success: 0,
  fail: 1,
};

const QRCODE_SCENE = {
  shopPickup: '1', // 自提门店扫码进入
};

const VOUCHER_PACKAGE = '1';

const ALERT_INFO = {
  minCost: 0, // 补差价
  productStatusChange: 1, // 商品状态变更,部分商品不可用
};

const MODULE_VIEW_ID = {
  DELIVERY_SWITCH_TAB: 'delivery_pickup_switch_tab', // 外送、自提切换
  DELIVERY_ADDRESS: 'delivery_address', // 地址信息
  FOOD_PROMOTION: 'food_promotion', // 菜品信息
  PAYMENT: 'payment', // 支付信息
  CPF: 'cpf', // CPF模块
  TABLEWARE: 'tableware', // 餐具信息
  CHARGE_TIPS: 'charge_tips', // 小费信息
  PUNCTUAL: 'punctual', // 准时保信息
  KOUPON_SELL: 'koupon_sell', // 券包模块
};

// ["delivery_pickup_switch_tab","delivery_address","payment","food_promotion","charge_tips","tableware"]
const DEFAULT_MODULE_VIEW_ID_LIST = [
  MODULE_VIEW_ID.DELIVERY_SWITCH_TAB,
  MODULE_VIEW_ID.DELIVERY_ADDRESS,
  MODULE_VIEW_ID.PAYMENT,
  MODULE_VIEW_ID.FOOD_PROMOTION,
  MODULE_VIEW_ID.CHARGE_TIPS,
  MODULE_VIEW_ID.TABLEWARE,
  // MODULE_VIEW_ID.PUNCTUAL,
];

// 图标点击热区
export const ICON_HITSLOP = {
  top: 4,
  bottom: 4,
  left: 4,
  right: 4,
};

// 缺货引导选择编码
enum STOCK_LACK_CODE {
  contact = 1, // 联系
  refund = 2, // 部分退款
  cancel = 3, // 取消整单
}

// 预览推荐地址类型
const PREVIEW_RECOMMAND_ADDRESS_TYPE = {
  HAS_RECOMMENDED: 1, // 有推荐地址
  NO_RECOMMENDED_WITH_LIST: 2, // 无推荐地址 && 地址列表不为空
  EMPTY_ADDRESS_LIST: 3, // 无推荐地址 && 地址列表为空, 即收货地址数量 ==0
};

enum SELECTED_ADDRESS_TYPE {
  map = 2,
  userAddress = 3,
}

// 检查核心数据类型
const CHECK_CORE_DATA_TYPE = {
  SCHEME_PARAMS: 'scheme_params', // 路由参数
  ORDER_UPDATE_REQUEST: 'order_update_request', // 订单更新请求
};

// 年龄分享状态
const AGE_SHARE_STATUS = {
  ACCEPT: 1, // 同意分享
  REJECT: 0, // 拒绝分享
};

export {
  SKIP_VERIFY_CODE,
  SAFE_AREA,
  SAFE_AREA_BOTTOM,
  ORDER_TOKEN_INVALID,
  ERROR_CODE,
  TIP_CODE,
  LX_CODES,
  ADDRESS_TYPE,
  UPDATE_TYPE,
  ADDRESS_STATUS,
  UPDATE_ERROR_CODE,
  REMARK_BAN,
  VOUCHER_MODULE_ADD_OFFSET,
  REFRESH_TOKEN_TYPE,
  CASHIER_DESK_TYPE,
  FRONT_PAYMENT_ACTION_TYPE,
  FRONT_PAYMENT_CODE,
  FRONT_PAYMENT_METHOD,
  CANCEL_ORDER_SCENE,
  PAY_RESPONSE_CASHIER_TYPE,
  INIT_PAYMENT_TIMEOUT_DURATION,
  DEFAULT_CANCEL_COUNT,
  SELECT_COUPON_TYPE,
  CHANGE_PAYMETHOD_REFERER_TYPE,
  SCROLL_OFFSET,
  PREVIEW_PROMAOTE_TEST_MARK_AB_SWITCH,
  SAVE_ADDRESS_ERROR_CODE,
  UPDATE_ADDRESS_STATUS,
  LARGE_ORDER_CODE,
  UserGetMode,
  UPDATE_STATUS,
  QRCODE_SCENE,
  ALERT_INFO,
  DEFAULT_MODULE_VIEW_ID_LIST,
  MODULE_VIEW_ID,
  STOCK_LACK_CODE,
  CANCEL_SCENE,
  PRE_DECISION_SCENE_CODE,
  HINT_EXPERIMENT,
  VOUCHER_PACKAGE,
  couponListSchemeCommonParams,
  PREVIEW_RECOMMAND_ADDRESS_TYPE,
  SELECTED_ADDRESS_TYPE,
  SAFETY_CHECK_CODE,
  CPF_CHECK_SCENE,
  CHECK_CORE_DATA_TYPE,
  AGE_SHARE_STATUS,
};

export const LABEL_ADDRESS_SEPARATOR = ' - ';

// 跳转到提单页的来源
// 0: 门店页
export const SOURCE = {
  SHOP: 0
};

export const RAPTOR_KEYS = reduceStrArrToMap(['BeforeRouterNavigateToOrderConfirm']);

export const KEY_PICKUP_BAR_CLOSE_TIMESTAMP = `${Mach.env.bundleName}/pickupBottombarCloseTimestamp`;
